export default __webpack_public_path__ + "static/media/team-1.501999e7.png";